import { render, staticRenderFns } from "./DeductionPay.vue?vue&type=template&id=d5834fc2&scoped=true&"
import script from "./DeductionPay.vue?vue&type=script&lang=js&"
export * from "./DeductionPay.vue?vue&type=script&lang=js&"
import style0 from "./DeductionPay.vue?vue&type=style&index=0&id=d5834fc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5834fc2",
  null
  
)

export default component.exports